import React from "react"; // eslint-disable-line
import { Comment, Form, Button, List, Input, message, Popconfirm } from "antd";
import DateViewer from '../../DateViewer';

const TextArea = Input.TextArea;

class Chat extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      textMessage: "",
      chat: props.chatData.chat,
      messageMode: 'regular',
      editMessageIndex: null
    };
  }

  static getDerivedStateFromProps(props, state) {
    if (props.chatData.chat !== state.chat) {
      return {
        chat: props.chatData.chat
      };
    }

    return null;
  }

  handleReadAll() {
    const { chat } = this.state;
    const { chatData, currentUid } = this.props;
    let haveUnreadMessage = false;

    const upDateChat = chat.map(message => {
      if (message.unread && message.userId !== currentUid) {
        haveUnreadMessage = true;

        return {
          ...message,
          unread: false
        }
      }

      return message;
    }).reverse();

    haveUnreadMessage && this.props.sendChatMessageAction(upDateChat, chatData.chatId)
      .then((res) => {
        if (res === 'success') {
          message.success('All unread messages are read.');
          this.setState({ loading: false, chat: upDateChat });
        }
      })
      .catch ((err) => {
        console.error(err);
        if (err) message.error("Server does not respond, try again later")
      })
  }

  handleDeleteMessage = (deleteIndex) => {
    const { chat } = this.state;
    const { chatData } = this.props;

    this.setState({loading: true});

    const modifiedChat = chat.map((message, index) => {
      if (index === deleteIndex) {
        return{
          ...message,
          deleted: true
        }
      }
      return message;
    });
    const updatedState = {
      loading: false, 
      chat: modifiedChat,
      messageMode: 'regular',
      editMessageIndex: null
    };

    this.props.sendChatMessageAction(modifiedChat, chatData.chatId)
      .then((res) => {
        if (res === 'success') {
          message.success('Message sent');
          this.setState(updatedState);
        }
      })
      .catch ((err) => {
        console.error(err);
        if (err) message.error("Server does not respond, try again later")
      })
  }

  handleSubmit() {
    if (!this.state.textMessage) {
      return;
    }

    let { textMessage, chat, messageMode, editMessageIndex } = this.state;
    let { chatData, currentUid } = this.props;

    let modifiedChat = chat;
    let resetStatetObj = {}

    this.setState({loading: true});

    if (messageMode === 'edit') {
      modifiedChat = chat.map((message, index) => {
        if (index === editMessageIndex) {
          return {
            ...message,
            message: textMessage,
            edited: true
          };
        }
        return message;
      });

      resetStatetObj = { 
        loading: false, 
        chat: modifiedChat, 
        textMessage: '', 
        messageMode: 'regular',
        editMessageIndex: null
      }
    }

    if (messageMode === 'regular') {
      const upDateChat = chat.map(message => {
        if (message.unread && message.userId !== currentUid) {
          return {
            ...message,
            unread: false
          }
        }
  
        return message;
      });

      let date = new Date();
      let messageObject = {
        date: `${date}`,
        message: textMessage,
        userId: currentUid,
        unread: true
      };

      modifiedChat = [...upDateChat, messageObject];
      resetStatetObj = { loading: false, chat: modifiedChat, textMessage: '' };
    }

    this.props.sendChatMessageAction(modifiedChat, chatData.chatId)
      .then((res) => {
        if (res === 'success') {
          message.success('Message sent');
          this.setState(resetStatetObj);
        }
      })
      .catch ((err) => {
        console.error(err);
        if (err) message.error("Server does not respond, try again later")
      })
  };

  handleChange (e) {
    this.setState({
      textMessage: e.target.value
    });
  };

  changeMessageMode = (index) => {
    const { chatData } = this.props;
    const messageInfo = chatData.chat && chatData.chat[index];

    this.setState(prevState => {
      const { editMessageIndex, messageMode } = prevState;
      let editIndex = null;
      let mode = 'regular';
      let message = '';
      if (messageMode === 'edit' && editMessageIndex !== index) {
        editIndex = index;
        mode = 'edit';
        message = messageInfo.message;
      }
      if (messageMode === 'regular') {
        editIndex = index;
        mode = 'edit';
        message = messageInfo.message;
      }

      return {
        messageMode : mode,
        editMessageIndex: editIndex,
        textMessage: message
      }
    });
  }

  renderCommentList(messages, currentUser, companionUser, currentUid) {
    if (messages[0].message === "zero mess") {
      messages.shift()
    }

    let sortByDate = messages.sort((a,b) => new Date(b.date) - new Date(a.date));

    if (messages.length === 1 && messages[0].message === "zero mess") {
      return (
        <div className="empty-text">
          <p>Write your first message</p>
        </div>
      )
    } else {
      return (
        <List
          dataSource={sortByDate}
          // header={`${messages.length} ${messages.length > 1 ? "replies" : "reply"}`}
          itemLayout="horizontal"
          className="current-chat"
          renderItem={(item, index) => (
            item.userId === currentUid ?
              this.renderComment(item, index, currentUser, '') :
              this.renderComment(item, index, companionUser, 'companion-comment')
          )}
        />
      )
    }
  }

  renderComment(item, index, user, style) {
    const { messageMode,editMessageIndex } = this.state;

    let date = <DateViewer date={item.date} isExact/>;

    const classNameStyle = messageMode === 'edit' && editMessageIndex === index ?
      'own-active-comment' : style;

    const deleteViewConditions = style !== 'companion-comment';
    const messageDate = (new Date(item.date)).getTime();

    const actions = ((Date.now() - messageDate) < 2 * 24 * 60 * 60 * 1000) ? [
      <span 
        onClick={() => this.changeMessageMode(index)}
        className="edit"
      >
        {/* <ItemAction 
          component={icons.edit} 
          text={'Edit'} 
        /> */}
        {
          messageMode === 'edit' && editMessageIndex === index ?
            "Cancel" : "Edit"
        }
      </span>,
      <Popconfirm 
        title={`Do you really want to delete this message?`} 
        onConfirm={() => this.handleDeleteMessage(index)} 
        onCancel={this.cancel} 
        okText="Yes" 
        cancelText="No"
      >
        <span>Delete</span>
      </Popconfirm>
    ] : [
      <Popconfirm 
        title={`Do you really want to delete this message?`} 
        onConfirm={() => this.handleDeleteMessage(index)} 
        onCancel={this.cancel} 
        okText="Yes" 
        cancelText="No"
      >
        <span>Delete</span>
      </Popconfirm>
    ];

    const generalConditionsForMessaging = (deleteViewConditions && !item.deleted) ? actions : [];

    return (
      <Comment
        className={classNameStyle}
        actions={generalConditionsForMessaging}
        // {...item}
        datetime={date}
        author={user.DisplayName || 'Name'}
        content={!item.deleted ? item.message : 'This message has been removed by the author.'}
        avatar={user.PhotoUrl}
      />
    )
  }

  render() {
    const { chatData, currentUser, currentUid } = this.props;
    const { loading, chat } = this.state;

    let haveUnreadMessage = false;

    chat.forEach(message => {
      if (message.unread && message.userId !== currentUid) {
        haveUnreadMessage = true;
      }
    });

    return (
      <React.Fragment>
        {chatData && chatData.chat.length > 0 && (
            this.renderCommentList(chat, currentUser, chatData.companionData, currentUid)
          )
        }
        <Form.Item className="current-chat-send-form">
          <TextArea
            rows={2}
            onFocus={() => this.handleReadAll()}
            onChange={(e) => this.handleChange(e)}
            onPressEnter={() => this.handleSubmit()}
            value={this.state.textMessage}
            placeholder="Type a message…"
          />
          <Button
            className="btn-success"
            type="primary"
            shape="circle"
            loading={loading}
            onClick={() => this.handleSubmit()}
            icon="arrow-up"
          />
        </Form.Item>
      </React.Fragment>
    );
  }
}

export default Chat;



// WEBPACK FOOTER //
// ./src/components/Modules/Chat/index.js